var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.56 12.7455L8.55 9.73555C8.25 9.43555 7.76 9.43555 7.46 9.73555L4.45 12.7355L4.3 12.6155C4.04 12.4155 3.82 12.1955 3.62 11.9455L3.5 11.8055L6.51 8.79555C6.88 8.42555 7.36 8.22555 7.84 8.18555C7.89 8.18555 7.94 8.18555 7.99 8.18555C8.04 8.18555 8.09 8.18555 8.14 8.18555C8.63 8.22555 9.1 8.42555 9.48 8.79555L12.49 11.8055L12.37 11.9555C12.17 12.1955 11.95 12.4255 11.7 12.6255L11.55 12.7455H11.56Z",
    fill: "#000D12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44 3.25488L7.45 6.26488C7.75 6.56488 8.24 6.56488 8.54 6.26488L11.55 3.25488L11.7 3.37488C11.96 3.57488 12.18 3.79488 12.38 4.04488L12.5 4.19488L9.49 7.20488C9.12 7.57488 8.64 7.77488 8.16 7.81488C8.11 7.81488 8.06 7.81488 8.01 7.81488C7.96 7.81488 7.91 7.81488 7.86 7.81488C7.37 7.77488 6.9 7.57488 6.52 7.20488L3.5 4.19488L3.62 4.04488C3.82 3.80488 4.04 3.57488 4.29 3.37488L4.44 3.25488Z",
    fill: "#000D12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWell);
export default __webpack_public_path__ + "static/media/well.5c0c08198412b6efaee7e0575273d58a.svg";
export { ForwardRef as ReactComponent };